import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function PersonLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { DataRequests } = useStore();
  const dataRequest = DataRequests.get(id);
  return (
    <div className={classNames({ [skeleton]: dataRequest.isPending }, className)}>
      {dataRequest.get('name', '(Unnamed)') as string}
    </div>
  );
}

export default observer(PersonLabel);
